export interface AyudPeriodo{
    estado: number,
    fechaaperturaayudantias: Date,
    fechaaperturatesistas: Date,
    fechacierreayudantias: Date,
    fechacierretesistas: Date,
    iddecinvayudtesperiodo: number,
    idperiodo: number,
    idpersona: number
}

export function VoidAyudPeriodo():AyudPeriodo{
  return{
    estado: 0,
    fechaaperturaayudantias: new Date,
    fechaaperturatesistas: new Date,
    fechacierreayudantias: new Date,
    fechacierretesistas: new Date,
    iddecinvayudtesperiodo: 0,
    idperiodo: 0,
    idpersona: 0
  }  
}